module.exports = __webpack_public_path__ + "img/icon_system_implementation_service.5be67bc9.svg";